'use client';

import { cn, getColorwayWithTransparency, getYMargins } from '@/utils/styles';
import CardsVerticalScrollItemMobile from './CardsVerticalScrollMobileItem';
import { CardsVerticalScrollProps } from './types';
import { Colorways, Margins } from '@/types/constants';

const CardsVerticalScroll = ({ sectionName, margins, transparentBackground, cards }: CardsVerticalScrollProps) => {
  const cardItems = cards?.items ?? [];

  return (
    <div
      id={sectionName}
      data-testid="mobile-version"
      className={cn(
        'relative md:hidden sm:block sm:overflow-visible w-full',
        getYMargins(margins ?? Margins.Centered),
        getColorwayWithTransparency(Colorways.DarkGreenGradientLeftToRight, transparentBackground),
      )}>
      {cardItems.map((card, index) => (
        <CardsVerticalScrollItemMobile {...card} key={card.sys.id} index={index} />
      ))}
    </div>
  );
};

export default CardsVerticalScroll;
